import { isCloseToDueDate, isOverDueDate } from "@/shared/utils";
import type { Note, NoteStatus, NoteTypes } from "@/services/api/entities/note/types";

type CardClassesKeys = NonNullable<NoteStatus> | "incoming" | "outgoing" | "note";

type CardClassesValues =
  | "card-to-do"
  | "card-done"
  | "card-in-progress"
  | "card-note"
  | "card-incoming"
  | "card-outgoing";

const cardClasses: Record<CardClassesKeys, CardClassesValues> = {
  TO_DO: "card-to-do",
  IN_PROGRESS: "card-in-progress",
  DONE: "card-done",
  note: "card-note",
  incoming: "card-incoming",
  outgoing: "card-outgoing",
};

export const getCardClass = ({
  dueDate,
  status,
  noteType,
  direction,
}: {
  dueDate: Date | number | string;
  status: NoteStatus;
  noteType: NoteTypes;
  direction: Note["direction"];
}) => {
  if (status === "DONE") {
    return cardClasses.DONE;
  }
  if (noteType !== "DEFAULT_COMMITMENT") {
    return cardClasses.note;
  }
  if (direction === "INCOMING") {
    return cardClasses.incoming;
  }
  if (typeof dueDate === "string" && isOverDueDate({ dueDate })) {
    return cardClasses.TO_DO;
  }
  if (isCloseToDueDate({ dueDate })) {
    return cardClasses.IN_PROGRESS;
  }
  return cardClasses.outgoing;
};
